import { CurrencyModel } from "../menus/currency.model";
import { MenuItemTypeEnum } from "../../enums/menu-item-type.enum";
import { SupplyModel } from "./supply-model";

export class MenuItemModel {
  public id: string;
  public name: string;
  public price: string;
  public priceWithTax: string;
  public description: string;
  public categoryName: string;
  public subcategoryName: string;
  public companyMenuCategoryId: string;
  public venueMenuCategoryId: string;
  public pictureURL: string;
  public currency: CurrencyModel;
  public menuItemTypeId: MenuItemTypeEnum;
  public supplies: Array<SupplyModel>;
}
